(function () {
    'use strict';
    angular.module('finansApp.courseFilterController', []).controller('courseFilterController', courseFilterController);

    courseFilterController.$inject = ['courseService', 'courseSortService', 'courseFilterService', '$filter', '$timeout', '$cookies', '$location'];


    function courseFilterController(courseService, courseSortService, courseFilterService, $filter, $timeout, $cookies, $location) {
        var vm = this;
        var $body = $('body');
        vm.state = courseFilterService.state;
        vm.courseService = {}
        vm.courseService.state = courseService.state

        vm.filterList = function () {

            // Set the filter in proper order
            courseFilterService.filterCourses(vm.courseService.state.courses).then(function (arr) {
                // Set the sort in proper order
                courseSortService.sortCourses(arr).then(function (data) {
                    vm.courseService.state.coursesFiltered = data;
                })

                // Once we have the data, init the images with responsive
                $timeout(function () {
                    novicell.responsiveLazyloadImage.onLoad();
                    finansudd.favorites.setFavoritesOnlist();
                }, 0);

            })

        }

        vm.toggleFilter = function (filterType) {

            if (filterType !== vm.state.showFilter) {
                vm.state.showFilter = filterType;
            } else {
                vm.state.showFilter = 0;
            }



        }

        vm.toggleMobileFilter = function () {
            toggleOverlay();
        }

        vm.saveViewCookie = function () {
            var tableView = vm.courseService.state.tableview;
            $cookies.put('table-view', tableView);
            
            if(tableView){
                $location.search('layout', 'list');
            }
            else {
                $location.search('layout', null);
            }

            // Once we have the data, init the images with responsive
            $timeout(function () {
                novicell.responsiveLazyloadImage.onLoad();
            }, 0);
        }

        vm.resetFilter = function () {
            vm.state.filter.SubjectAreas = [];
            vm.state.filter.Types = [];
            vm.state.filter.TargetAudiences = [];

            vm.filterList();
        }

        vm.filterCourses = function (alias, id) {
            var arr = vm.state.filter[alias];

            if (arr.length && contains.call(arr, id)) {
                var index = arr.indexOf(id);
                if (index > -1) {
                    arr.splice(index, 1);
                }
            } else {
                arr.push(id);
            }

            vm.filterList();
            // Set the url
            setUrl();
        }

        vm.removeFilter = function (alias, id) {
            var arr = vm.state.filter[alias];
            var index = arr.indexOf(id);

            if (index > -1) {
                arr.splice(index, 1);
            }

            vm.filterList();

            setUrl();
        }



        function init() {
            courseService.getCourses().then(getDataFromUrl, getDataFromUrl)
        }

        function toggleOverlay() {

            if ($body.hasClass('open-overlay')) {
                $body.removeClass('open-overlay');
            } else {
                $body.addClass('open-overlay');
            }
        }


        // Helper method to check if a array contains a value
        var contains = function (needle) {
            // Per spec, the way to identify NaN is that it is not equal to itself
            var findNaN = needle !== needle;
            var indexOf;

            if (!findNaN && typeof Array.prototype.indexOf === 'function') {
                indexOf = Array.prototype.indexOf;
            } else {
                indexOf = function (needle) {
                    var i = -1, index = -1;

                    for (i = 0; i < this.length; i++) {
                        var item = this[i];

                        if ((findNaN && item !== item) || item === needle) {
                            index = i;
                            break;
                        }
                    }

                    return index;
                };
            }

            return indexOf.call(this, needle) > -1;
        };


        function getDataFromUrl(data) {
            var params = $location.search();
            var filters = $location.$$hash.split(',');

            if (typeof (params['filter']) !== 'undefined' && params['filter']) {
                filters = filters.concat(params['filter'].split(","));
            }

            filters.forEach(function(el) {
                var filter = data.Filters[el];

                if(typeof filter != 'undefined' && filter) {
                    var elAsInt = el * 1;
                    vm.state.filter[filter.Category].push(elAsInt);
                }
            });


            // Remove the hashes;
            $location.$$hash = null;
            
            setUrl();
        }

        function setUrl() {
            var params = $location.search();

            if (typeof vm.state.filter !== 'undefined' && vm.state.filter) {
                params.filter = vm.state.filter.SubjectAreas;
                params.filter = params.filter.concat(vm.state.filter.Types);
                params.filter = params.filter.concat(vm.state.filter.TargetAudiences);
                params.filter = params.filter.join(",");
            }

            $location.search(params);

        }




        init();


    }

})();